
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/products",
      function () {
        return require("private-next-pages/shopping/products.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping/products"])
      });
    }
  